import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import URL from 'modules/url'
import assets from 'modules/assets'
import * as actions from 'actions'
import * as camps from 'modules/camps'

// generic
import Spinner from 'components/Utils/Spinner'
import TopWrapper from 'components/Utils/TopWrapper'
import Footer from 'components/Utils/Footer'
import LargeQuote from 'components/Utils/LargeQuote'
import Carousel from 'components/Utils/Carousel'
import RowThreeText from 'components/Utils/RowThreeText'
import RowThreeBlock from 'components/Utils/RowThreeBlock'
import RowThreeImage from 'components/Utils/RowThreeImage'
import RowFour from 'components/Utils/RowFour'
import Location from 'components/Utils/Location'
import AlertMini from 'components/Utils/AlertMini'

import FAQ from 'components/Utils/FAQ'


// specific to camp
import Timeline from 'components/Utils/Timeline'  // change to generic component?
import Archive from './Archive/Archive'
import Sempai2017 from './camps/2017/Sempai2017'


class Camps extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView()

    let { dispatch } = this.props,
        url = URL(this.props)
    dispatch(actions.token.fetchData(url))
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    let intro, links, links2, location, team, faq, externalVideos
    if (this.state && this.state.data) {
      intro = camps.intro(this.state.data)
      links = camps.links(this.state.data)
      links2 = camps.links2(this.state.data)
      location = camps.location(this.state.data)
      team = camps.team(this.state.data)
      faq = camps.faq(this.state.data)
      externalVideos = camps.externalVideos(this.state.data)
    }

    if (!this.state || !this.state.data) {
      return <main className='camp'><Spinner /></main>
    } else {
      let scrollApplyIntoView = false
      if (this.state.location.hash == '#apply') {
        scrollApplyIntoView = true
        this.props.router.push(this.state.location.pathname)
      }

      let alertMiniIfNecessary = <AlertMini alertIsMinimized={true} />
      return (
        <main className="page fade-in">
          {alertMiniIfNecessary}
          <div className="group0 parallax__group">
            <div className="layer parallax__layer--deep">
              <img src={assets('images/H_Blob-3.png')} style={{width: '100%', height: 'auto'}} />
            </div>

            <div className="layer parallax__layer--base" style={{maxHeight: '100%'}}>
              <RowThreeText data={intro} />
              <RowFour data={location} />
              <RowThreeText isScrollIntoView={scrollApplyIntoView} data={links} />
              <Carousel start={1} end={18} />
              <div className="gakko-video orange">
                <iframe src="https://player.vimeo.com/video/195932509" height="100%" frameBorder="0" allowFullScreen></iframe>
              </div>
              <RowThreeBlock data={externalVideos} />
              <Archive />
              <RowFour data={team} />
              <FAQ data={faq}  />
              <img src={assets('images/blobs/02.png')} style={{width: '100%', height: 'auto', marginTop: '5vh', marginBottom: '-2vh'}} />
              <Footer />
            </div>
          </div>
        </main>
      )
    }
  }
}
/*
  <Sempai2017 isScrollIntoView={scrollSempaiIntoView}/>
  <Timeline data={timeline} />
*/
Camps.contextTypes = {
}
Camps.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    data: state.token.data,
    alertIsMinimized: state.token.alertIsMinimized,
    scrollDirection: state.token.scrollDirection
  }
}

export default connect(mapStateToProps)(Camps)



// WEBPACK FOOTER //
// ./src/components/Camps.js